import { ApiService } from "./ApiService";

export class WaMessageService {
    static uri = '/wa/message';

    static get({ params }) {
        return ApiService.get(this.uri, {
            params,
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token-radiustrend')}`
            }
        });
    }

    static create({ data }) {
        return ApiService.post(`${this.uri}/create`, data, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${localStorage.getItem('token-radiustrend')}`
            }
        });
    }

    static send({ data }) {
        return ApiService.post(`${this.uri}/send`, data, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${localStorage.getItem('token-radiustrend')}`
            }
        });
    }
    static resend({ data }) {
        return ApiService.post(`${this.uri}/resend`, data, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${localStorage.getItem('token-radiustrend')}`
            }
        });
    }

    static update({ data, id }) {
        return ApiService.post(`${this.uri}/update/${id}`, data, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${localStorage.getItem('token-radiustrend')}`
            }
        });
    }

    static delete({ id }) {
        return ApiService.post(`${this.uri}/delete/${id}`, {}, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token-radiustrend')}`
            }
        });
    }
}